'use strict';

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null;
}; // Customized for this use-case


var isObjectCustom = function isObjectCustom(value) {
  return isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
};

var mapObject = function mapObject(object, mapper, options) {
  var isSeen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new WeakMap();
  options = _objectSpread({
    deep: false,
    target: {}
  }, options);

  if (isSeen.has(object)) {
    return isSeen.get(object);
  }

  isSeen.set(object, options.target);
  var _options = options,
      target = _options.target;
  delete options.target;

  var mapArray = function mapArray(array) {
    return array.map(function (element) {
      return isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element;
    });
  };

  if (Array.isArray(object)) {
    return mapArray(object);
  }

  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var _mapper = mapper(key, value, object),
        _mapper2 = _slicedToArray(_mapper, 2),
        newKey = _mapper2[0],
        newValue = _mapper2[1];

    if (options.deep && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
    }

    target[newKey] = newValue;
  }

  return target;
};

module.exports = function (object, mapper, options) {
  if (!isObject(object)) {
    throw new TypeError("Expected an object, got `".concat(object, "` (").concat(typeof object, ")"));
  }

  return mapObject(object, mapper, options);
};